import { useTranslation } from 'react-i18next';

export interface ColumnDef {
  key: string;
  label: string;
  required?: boolean;
}

interface Props {
  columns: ColumnDef[];
  visible: string[];
  onChange: (visible: string[]) => void;
}

export default function ColumnPicker({ columns, visible, onChange }: Props) {
  const { t } = useTranslation('views');

  function toggle(key: string) {
    if (visible.includes(key)) {
      onChange(visible.filter((k) => k !== key));
    } else {
      // Maintain declaration order
      const ordered = columns.map((c) => c.key).filter((k) => k === key || visible.includes(k));
      onChange(ordered);
    }
  }

  return (
    <div style={{
      background: 'var(--color-bg)', border: '1px solid var(--color-border)',
      borderRadius: 'var(--radius-lg)', padding: 'var(--space-3)',
      display: 'flex', flexDirection: 'column', gap: 'var(--space-1)',
      minWidth: 200,
    }}>
      <p style={{ fontSize: 'var(--text-xs)', fontWeight: 'var(--font-medium)', color: 'var(--color-text-secondary)', marginBottom: 'var(--space-1)' }}>
        {t('columns.title')}
      </p>
      {columns.map((col) => {
        const isVisible = visible.includes(col.key);
        return (
          <label
            key={col.key}
            style={{
              display: 'flex', alignItems: 'center', gap: 'var(--space-2)',
              padding: '3px var(--space-1)', cursor: col.required ? 'default' : 'pointer',
              fontSize: 'var(--text-sm)', color: 'var(--color-text)', borderRadius: 'var(--radius-sm)',
            }}
          >
            <input
              type="checkbox"
              checked={isVisible}
              disabled={col.required}
              onChange={() => toggle(col.key)}
              style={{ cursor: col.required ? 'default' : 'pointer' }}
            />
            {col.label}
          </label>
        );
      })}
    </div>
  );
}
